




























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { OrderType, ReferralFilterDirection, ReferralView } from '@/api/types'
import { isEqual } from 'lodash'
import { namespace } from 'vuex-class'
import { CompanyAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
const orders = namespace('orders')

@Component
export default class OrderFacets extends Vue {
    @Prop({ type: Boolean, default: false }) visible!: boolean
    @orders.State readonly loading!: boolean
    @orders.State readonly view!: string
    @orders.State readonly direction!: string
    @orders.State readonly typeFilter!: OrderType[]
    @orders.State readonly referredByFilter!: User
    @orders.State readonly referredByBranchFilter!: Branch
    @orders.State readonly assignedToFilter!: User
    @orders.State readonly assignedToBranchFilter!: Branch
    @orders.Action applyView: ({ view: ReferralView, direction: ReferralFilterDirection }) => Promise<void>
    @orders.Action applyTypeFilter: ({ typeFilter }) => Promise<void>
    @orders.Action applyReferredByFilter: ({ referredByFilter, update }) => Promise<void>
    @orders.Action applyReferredByBranchFilter: ({ referredByBranchFilter }) => Promise<void>
    @orders.Action applyAssignedToFilter: ({ assignedToFilter, update }) => Promise<void>
    @orders.Action applyAssignedToBranchFilter: ({ assignedToBranchFilter }) => Promise<void>
    availableOutgoingBranches: Branch[] = []
    availableOutgoingUsers: User[] = []

    async mounted(): Promise<void> {
        await this.loadOutgoingBranches()
        await this.loadOutgoingUsers()
    }

    async loadOutgoingBranches(): Promise<void> {
        this.availableOutgoingBranches = (await CompanyAPI.getOutgoingReferralBranches())
            .sort((a: Branch, b: Branch) => a.name.localeCompare(b.name))
    }

    async loadOutgoingUsers(): Promise<void> {
        const availableUsers = new Map<string, User>()

        this.availableBranches.forEach(branch => {
            branch.company.getAvailableUsers({ branch }).forEach(user => {
                availableUsers.set(user.id, user)
            })
        })

        this.availableOutgoingUsers = Array.from(availableUsers.values())
            .sort((a: User, b: User) => a.name.localeCompare(b.name))
    }

    onViewChanged(value: ReferralView): void {
        if (this.view === value) {
            return
        }

        this.applyView({
            view: value,
            direction: this.direction,
            update: true,
        } as any)
    }

    onDirectionChanged(value: ReferralFilterDirection): void {
        if (this.direction === value) {
            return
        }

        this.applyView({
            view: this.view,
            direction: value,
            update: true,
        } as any)
    }

    onTypeChanged(value: OrderType[]): void {
        if (isEqual(this.typeFilter, value)) {
            return
        }

        this.applyTypeFilter({
            typeFilter: value,
        })
    }

    onReferredByFilterChanged(value: User[]): void {
        if (isEqual(this.referredByFilter, value)) {
            return
        }

        this.applyReferredByFilter({
            referredByFilter: value,
            update: true,
        })
    }

    onReferredByBranchFilterChanged(value: Branch[]): void {
        if (isEqual(this.referredByBranchFilter, value)) {
            return
        }

        this.applyReferredByBranchFilter({
            referredByBranchFilter: value,
        })
    }

    onAssignedToFilterChanged(value: User[]): void {
        if (isEqual(this.assignedToFilter, value)) {
            return
        }

        this.applyAssignedToFilter({
            assignedToFilter: value,
            update: true,
        })
    }

    onAssignedToBranchFilterChanged(value: Branch[]): void {
        if (isEqual(this.assignedToBranchFilter, value)) {
            return
        }

        this.applyAssignedToBranchFilter({
            assignedToBranchFilter: value,
        })
    }

    get availableBranches(): Branch[] {
        return this.availableOutgoingBranches
    }

    get availableUsers(): User[] {
        return this.$currentCompany.getAvailableUsers()
    }

    get directionOptions() {
        return [
            { label: `Door ${this.view === 'user' ? 'mij' : 'mijn team'} af te handelen`, value: 'in' },
            { label: `Voor ${this.view === 'user' ? 'mijn' : 'mijn team'} leads`, value: 'out' },
        ]
    }

    get viewOptions() {
        return [
            { label: 'Mijn opdrachten', value: 'user' },
            { label: 'Team opdrachten', value: 'branches' },
        ]
    }

    get orderTypeOptions(): Array<{ label: string, value: string }> {
        return [
            { label: 'Aankoop', value: OrderType.PURCHASE },
            { label: 'Verkoop', value: OrderType.SALE },
            { label: 'Hypotheek', value: OrderType.MORTGAGE },
            { label: 'Verhuur', value: OrderType.RENTAL },
        ]
    }
}
